module.exports = __webpack_public_path__ + "img/acai.ffb06e9d.svg";